import { NgModule } from '@angular/core';
import { AnnotatorCommentBtnDirective } from './shared/annotator-comment-btn.directive';
import { AnnotatorContainerDirective } from './shared/annotator-container.directive';
import { AnnotatorFileDirective } from './shared/annotator-file.directive';
import { AnnotatorCommentsPanelComponent } from './annotator-comments-panel/annotator-comments-panel.component';
import { AnnotatorCommentDirective } from './shared/annotator-comment.directive';
import { AnnotatorDesignToolsComponent } from './annotator-design-tools/annotator-design-tools.component';
import { RlCommonModule } from '../rl-common/rl-common.module';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { CommentModule } from '../rl-common/comment/comment.module';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { AnnotationInterceptor } from './core/annotation.interceptor';



@NgModule({
  declarations: [
    AnnotatorContainerDirective,
    AnnotatorCommentBtnDirective,
    AnnotatorFileDirective,
    AnnotatorCommentsPanelComponent,
    AnnotatorCommentDirective,
    AnnotatorDesignToolsComponent
  ],
  imports: [
    RlCommonModule,
    CommentModule,
    BsDropdownModule.forRoot(),
    TooltipModule.forRoot()
  ],
  providers : [
    {provide : HTTP_INTERCEPTORS, useClass : AnnotationInterceptor, multi : true}
  ],
  exports : [
    AnnotatorContainerDirective,
    AnnotatorFileDirective,
    AnnotatorCommentBtnDirective,
    AnnotatorCommentsPanelComponent,
    AnnotatorCommentDirective,
    AnnotatorDesignToolsComponent
  ]
})
export class AnnotationsModule { }
